import { chat, kinoParticipants } from "../../libs/roomnew";
import { debounce } from "../base/video-quality/actions";
import moment from 'moment';
import {
    participantsSubtitle,
    renderInitialsAvatarHtml,
} from "./uiHelpers";

const chatList = $('#all-chats-list-container');
import tippy from 'tippy.js';

const normalizeListAttr = (value) => {
    if (!value || value === 'null' || value === 'undefined') return null;
    return value;
};

const applyDraftPreviewToRow = ($el, preview) => {
    if (!$el?.length) return;
    const cont = $el.find('.chat-last-message-cont');
    const fallback = $el.attr('data-fallback-preview') ?? '';
    if (preview) {
        cont.text(preview);
        $el.find('.list-chat-last-message').addClass('has-draft');
    } else {
        cont.html(fallback);
        $el.find('.list-chat-last-message').removeClass('has-draft');
    }
};

export const refreshDraftListPreviews = () => {
    if (typeof chat.getConversationDraftPreview !== 'function') return;
    chatList.children('.list-chat-item').each((_, el) => {
        const $el = $(el);
        const preview = chat.getConversationDraftPreview({
            group: normalizeListAttr($el.attr('groupid')),
            pId: normalizeListAttr($el.attr('participant')),
        });
        applyDraftPreviewToRow($el, preview);
    });
};
export const renderChatsList=()=>{
    const filter = $("#chats-search-input").val();
    let chats = orderChatsByLastMessageTime(getFormattedChats());
    console.log("Ordered chats",chats)
    if (filter) {
        chats = chats.filter((fchat) => {
            return fchat.name.toLowerCase().search(filter.toLowerCase()) > -1;
        });
    }
    chatList.empty();
    chats.forEach((renderchat) => {
        renderChatItem(renderchat);
    });
}

export const debounceSearchChats = debounce(renderChatsList, 200);

export function formatMessageTime(momentTime) {
    if(!momentTime){return ''}
    const now = moment();
    const daysDiff = now.diff(momentTime, 'days');
    const yearsDiff = now.diff(momentTime, 'years');

    if (daysDiff === 0) {
        // If it's today, format as hh:mm
        return momentTime.local().format('hh:mm A');
    } else if (yearsDiff >= 1) {
        // If it's more than 1 year ago, format as DD/MM/YYYY
        return momentTime.local().format('YYYY/MM/DD');
    } else {
        // If it's later than today but within a year, format as DD/MM
        return momentTime.local().format('MM/DD');
    }
}

export const renderChatItem=(renderchat)=>{

    const chatLogo = $('<div>', {
        class: 'list-chat-logo',
        html: [
            renderInitialsAvatarHtml(renderchat.name, 46),
            `<span class="user-status-badge ${renderchat.isOnline ?? ''}"></span>`
        ],
    });
    const unreadCount = renderchat.unread > 99 ? '99+' : renderchat.unread;
    const unreadBadge=$('<span/>',{
        class:'unread-badge',
        html: renderchat.unread > 0 ? unreadCount : '',
    })
    const chatName = $('<div>', {
        class: 'list-chat-name',
        html: [`<span>${renderchat.name}</span>`,unreadBadge]
    });

    const draftPreview = chat.getConversationDraftPreview(renderchat);
    const lastMessage = $('<div>', {
        class: `list-chat-last-message${draftPreview ? ' has-draft' : ''}`,
        html: [
            $('<span>', {
                class: 'chat-last-message-cont',
                ...(draftPreview ? { text: draftPreview } : { html: renderchat.lastMessage }),
            }),
            $('<span>', {
                class: 'last-message-time',
                text: formatMessageTime(renderchat?.lastMessageTime),
            }),
        ],
    });

    const chatItemContent = $('<div>', {
        class: 'list-chat-item-content',
        html: [chatName, lastMessage]
    });
    tippy(chatName[0], {
        content: renderchat.name,
        allowHTML: false,
        placement: 'top',
        theme: 'light',
        arrow: false,
        offset: [0, 0],
        duration: 0,
        delay: [1000, 0],
        animation: 'shift-away',
        interactive: true,
    })
    const chatItem = $('<div>', {
        class: `list-chat-item ${isChatSelected(renderchat) ? 'active' : ''}`,
        groupid: renderchat.group,
        participant: renderchat.pId,
        'data-fallback-preview': renderchat.lastMessage ?? '',
        html:[chatLogo, chatItemContent]
    }).on('click', function(){
        chat.setChatselected(renderchat);
        if(renderchat.group){
            setSelectedChatActive(renderchat.group);
        }else{
            chatList.find('.list-chat-item').removeClass('active');
            $(this).addClass('active');
            renderChatHeader(createTemporaryChat([
                {guest_id: renderchat.pId, displayName: renderchat.name, user_id: 0},
                {guest_id: chat.myUniqueId, displayName: chat.myDisplayName, user_id: USER_ID}
            ]));
        }
    });

    chatList.append(chatItem);
    if(isChatSelected(renderchat)){
        renderChatHeader(renderchat);
    }
}
const isChatSelected = (c)=> chat.isConversationSelected(c);

export const setSelectedChatActive=(chatId)=>{
    chatList.find('.list-chat-item').removeClass('active');
    $(`.list-chat-item[groupid="${chatId}"]`).addClass('active');
    const selectedChat = findChatById(chatId);
    renderChatHeader(selectedChat);
}

const createTemporaryChat=(participants)=>{
    const tempChat = {
          pId: null,
          group: null,
          members: participants,
          name: participants
          .filter(
            (participant) =>
              participant.guest_id != chat.myUniqueId &&
              (USER_ID == 0 || participant.user_id != USER_ID)
          )
          .map((participant) => participant.displayName)
          .join(", "),
          isChat: false,
          lastMessage: 'Tap to chat',
          isOnline: false,
    }
    return tempChat
}

const getFormattedChats=()=>{
    const participants = chat.getChatsListArray();
    console.log("Participants",participants)
    chat.groupUniqueParticipants().forEach((el) => {
        // Hide members who were removed from the workspace (no chat permission)
        // and have no existing chat history. They stay visible only if a chat
        // already exists with them (handled via getChatsListArray groups).
        if (!chat.participantHasChat(el) && !chat.participantHasChatHistory(el)) {
            return;
        }
        participants.push({
          pId: el,
          group: null,
          members: [],
          name: chat.getParticipantDisplayName(el),
          isChat: false,
          lastMessage: 'Tap to chat',
          isOnline: chat.isParticipantOnline(el),
          unread: 0,
        });
    });
    return participants;
}

export const orderChatsByLastMessageTime=(chats)=>{
    return chats.sort((a, b) => {
        const timeA = a.lastMessageTime ?? null;
        const timeB = b.lastMessageTime ?? null;

        // Always move chats with null lastMessageTime to the end
        if (timeA === null) return 1;  // `a` has null, so it goes after `b`
        if (timeB === null) return -1; // `b` has null, so it goes after `a`

        // Sort in descending order if both have valid lastMessageTime
        return timeB.diff(timeA);
    });
}

export const renderChatHeader = (currentchat=null)=>{
    const selectedChat = currentchat || getSelectedChat();
    if(selectedChat){
        const chatHeader = $('#current-chat-header');
        const chatName = selectedChat?.name || 'Public Chat';
        const onlineCount = kinoParticipants.getParticipants().length;
        const pcount = participantsSubtitle(selectedChat, onlineCount);
        chatHeader.find('.header-chat-icon').html(renderInitialsAvatarHtml(chatName, 38));
        chatHeader.find('.chat-name').html(chatName);
        chatHeader.find('.chat-participants').html(pcount);

    }
}

const getSelectedChat=()=>{
    const chats = chat.getChatsListArray();
    return chats.find((c) => c.group === chat.selectedChatId);
}

export const findChatById=(chatId)=>{
    const chats = chat.getChatsListArray();
    return chats.find((c) => c.group === chatId);
}

export const updateChatBadge=(group_id,unread)=>{
    console.trace("Update chat badge")
    const chatItem = chatList.find(`.list-chat-item[groupid="${group_id}"]`);
    const group = chat.groups.find(g=>g.id == group_id);
    const lastMessage = group.lastMessage ?? chat.getChatLastMessage(group_id)
    if(unread !== false) {
        const count = unread > 99 ? '99+' : unread;
        chatItem.find('.unread-badge').html(unread > 0 ? count : '');
    }
    chatItem.attr('data-fallback-preview', lastMessage ?? '');
    applyDraftPreviewToRow(chatItem, chat.getConversationDraftPreview({ group: group_id }));
}
